import _ from 'lodash';
import { AU_MEDICARE, AU_PASSPORT } from '_config/au/constants';
import { MEDICARE_CARD_GREEN } from '_config';
import { isAU } from 'utils/byConfig';
import {
  NZ_PASSPORT,
  NZ_BIRTH_CERTIFICATE,
  NZ_CITIZENSHIP,
  NZ_FIREARM_LICENSE,
  RELATED_PASSPORT,
  NZ_DRIVERS_LICENCE,
} from 'store';

export function toIdvPayload(values) {
  return isAU() ? toAUIdvPayload(values) : toNZIdvPayload(values);
}

export function toAUIdvPayload(values) {
  const idAUPassport = toIdAuPassport(values);
  const idAUMedicare = toAuMedicare(values);
  return {
    idType: values.idType,
    idAUPassport,
    idAUMedicare,
  };
}

export function toNZIdvPayload(values) {
  const idAUPassport = toIdAuPassport(values);
  const idNZPassport = toIdNzPassport(values);
  const idNZDriversLicence = toNzDriversLicence(values);
  const idNZBirthCertificate = toIdNzBirthCertificate(values);
  const idNZCitizenship = toIdNzCitizenship(values);
  const idNZFirearmLicence = toIdNzFirearmLicense(values);
  const idRelatedPassport = toIdRelatedPassport(values);
  const idOtherPassport = toIdOtherPassport(values);
  return _.omitBy(
    {
      idType: values.idType,
      idAUPassport,
      idNZPassport,
      idNZBirthCertificate,
      idNZCitizenship,
      idNZDriversLicence,
      idNZFirearmLicence,
      idRelatedPassport,
      idOtherPassport,
    },
    _.isNull,
  );
}

function toIdAuPassport(values) {
  if (values.idType !== AU_PASSPORT) {
    return null;
  }

  return {
    issuingCountry: 'AU',
    idNumber: values.idNumber,
    ...(values.dvsConsent !== undefined ? { dvsConsent: values.dvsConsent } : {}),
  };
}

function toAuMedicare(values) {
  if (values.idType !== AU_MEDICARE) {
    return null;
  }

  const name = JSON.parse(values.name || '{}');
  const expiryDate =
    values.medicareCardColour === MEDICARE_CARD_GREEN
      ? {
          day: lastDayOfMonth(values.expiryDateGreen.month, values.expiryDateGreen.year),
          month: Number(values.expiryDateGreen.month),
          year: Number(values.expiryDateGreen.year),
        }
      : {
          day: Number(values.expiryDateNonGreen.day),
          month: Number(values.expiryDateNonGreen.month),
          year: Number(values.expiryDateNonGreen.year),
        };

  return {
    expiryDate,
    medicareCardNumber: values.medicareCardNumber,
    individualReferenceNumber: values.individualReferenceNumber,
    medicareCardMiddleName: name.middleName || null,
    medicareCardColour: values.medicareCardColour,
  };
}

function toIdNzPassport(values) {
  if (values.idType !== NZ_PASSPORT) {
    return null;
  }

  return {
    idNumber: values.idNumber,
    expiryDate: values.expiryDate,
  };
}

function toNzDriversLicence(values) {
  if (values.idType !== NZ_DRIVERS_LICENCE) {
    return null;
  }

  return {
    licenceNumber: values.licenceNumber,
    version: values.version,
    expiryDate: values.expiryDate,
  };
}

function toIdNzBirthCertificate(values) {
  if (values.idType !== NZ_BIRTH_CERTIFICATE) {
    return null;
  }

  return {
    certificateNumber: values.idNumber,
  };
}

function toIdNzCitizenship(values) {
  if (values.idType !== NZ_CITIZENSHIP) {
    return null;
  }

  return {
    certificateNumber: values.idNumber,
  };
}

function toIdRelatedPassport(values) {
  if (values.idType !== RELATED_PASSPORT) {
    return null;
  }

  return {
    idNumber: values.idNumber,
    expiryDate: values.expiryDate,
    issuingCountry: values.issuingCountry,
  };
}

function toIdOtherPassport(values) {
  if (values.idType !== RELATED_PASSPORT) {
    return null;
  }

  return {
    idNumber: values.idNumber,
    expiryDate: values.expiryDate,
    issuingCountry: values.issuingCountry,
    nzResidencyNumber: values.nzResidencyNumber,
    visaStartDate: values.visaStartDate,
    visaEndDate: values.visaEndDate,
  };
}

function toIdNzFirearmLicense(values) {
  if (values.idType !== NZ_FIREARM_LICENSE) {
    return null;
  }

  return {
    licenceNumber: values.licenceNumber,
    expiryDate: values.expiryDate,
  };
}

function lastDayOfMonth(monthStr, yearStr) {
  const month = Number(monthStr);
  const year = Number(yearStr);

  // Create a date object of the next month, first day
  const date = new Date(year, month, 1);

  // Subtract one day to get the last day of the previous month
  date.setDate(date.getDate() - 1);

  return date.getDate();
}
